import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger);

export function bannerAbout() {
    const banner = document.querySelector('.banner--about');

    if (!banner) {
        return;
    }

    const headingAnim = gsap.timeline();
    const bgShape = gsap.timeline();

    headingAnim.to('.reveal', {
        opacity: 1,
        duration: 1
    });

    /*  bgShape.set('.bg-shape', {
        y: 100
    }); */
    bgShape.to('.bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2,
        stagger: 0.3
    });
    bgShape.call(updateShapes);

    bgShape.to('.bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });

    gsap.to('.banner__content', {
        opacity: 0,
        y: -100,
        scrollTrigger: {
            trigger: '.banner--about',
            start: 'clamp(top 130px)',
            scrub: 2
        }
    });

    gsap.set('.bg-shape', {
        opacity: 1
    });
    gsap.utils.toArray('.bg-shape__wrapper').forEach((shape) => {
        gsap.to(shape, {
            y: -gsap.utils.random(50, 300),
            opacity: 0,
            scrollTrigger: {
                trigger: '.banner--about',
                start: 'clamp(top 130px)',
                end: 'bottom top',
                scrub: 2
            }
        });
    });

    const shapes = document.querySelectorAll('.shape-path');
    const shapesMorph = gsap.timeline({
        repeat: -1,
        yoyo: true,
        onRepeat: updateShapes
    });
    let colors = ['#FF7BBF', '#FAF161', '#71DEF2', '#C4A3FF', '#00D1A6'];
    let previousShapes = new Array(shapes.length).fill(null);
    let previousColors = new Array(shapes.length).fill(null);

    function updateShapes() {
        // Shuffle the shapes array before starting the loop
        const shuffledShapes = [...shapes].sort(() => Math.random() - 0.5);

        shuffledShapes.forEach(function (shape, index) {
            let newShape;
            do {
                newShape = gsap.utils.random([
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 15, 16
                    //14,10,11 don't work well
                ]);
            } while (newShape === previousShapes[index]);

            previousShapes[index] = newShape;

            let newColor;
            do {
                newColor = gsap.utils.random([0, 1, 2, 3, 4]);
            } while (newColor === previousColors[index]);

            previousColors[index] = newColor;

            shapesMorph.to(
                shape,
                {
                    morphSVG: {
                        shape: '#shape' + newShape,
                        map: 'complexity',
                        type: 'linear'
                    },
                    fill: colors[newColor],
                    duration: 2,
                    ease: 'elastic.inOut',
                    stagger: index * 0.5
                },
                '>-0.5'
            );
        });
    }
}
